__turbopack_context__.v({
  "email-iframe": "CustomerNotificationModal-module-scss-module__BPwptq__email-iframe",
});
